// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ad3dcfed","565":"5c495e73","574":"9dfa2e29"}[chunkId] + ".chunk.js";
};